import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import InputNumber from 'rc-input-number';
import styles from './RetailerDetails.module.scss';
import StoresModal from '../StoresModal';
import WarehousesModal from '../../modals/WarehousesModal';
import { formatMany, numberFormatter } from '../../../utils/formatHelper';
import ShipperAccount from '../ShipperAccount';
import AccountIdConfigModal from '../../modals/AccountIdConfigModal';
import { withMixpanel } from 'react-mixpanel-browser';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { isEmpty } from 'lodash';
import { SHOPIFY_CUSTOMER_TYPE } from '../../../store/constants/shopifyTypes';
import { InfoTooltip } from '../../common/InfoTooltip';
import {
  accountIdConfigTooltip,
  getAccountIdInputText,
} from '../../modals/AccountIdConfigModal/Form/helpers/accountIdConfigTooltip';
import {
  copyAccountIdToClipboard,
  shouldShowCopyAccountIdButton,
} from '../../modals/AccountIdConfigModal/Form/helpers/copyAccountIdToClipboard';
import { SHOPIFY_INTEGRATION_TYPE, WOO_COMMERCE_INTEGRATION_TYPE } from '../../../constants/integrationTypes';
import { TikTokBrandIdMapperModal } from '../../integrations/tiktok/TikTokBrandIdMapperModal';
import Radio from '../../common/Radio';
import RadioGroup from '../../common/RadioGroup';
import { DISABLED, ENABLED } from '../../../constants/permissions';

const CUSTOMER_ROLE = 'costumer';

class RetailerDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openStores: false,
      openAccountIdModal: false,
      openWarehouses: false,
      editErpId: false,
      blockErpIdEdit: false,
      erpId: this.retailerIdIsSourceToErpID(this.props.retailer_id_in_source),
      editBuffer: false,
      buffer: this.props.buffer,
      approvedWarehouses: this.props.approved_warehouses,
      editMaximumInventory: false,
      maximumInventory: this.props.max_inventory_visible,
      shopifyWarehouseId: null,
      wooCommerceWarehouseId: null,
      accountIdTypes: this.props.account_id_types,
      openTikTokBrandIdMapperModal: false,
    };
  }

  blockErpIdEdit() {
    this.setState({
      blockErpIdEdit: true,
    });
  }

  retailerIdIsSourceToErpID(retailerIdInSource) {
    if (!retailerIdInSource) {
      return '';
    }
    try {
      const json = JSON.parse(this.props.retailer_id_in_source);
      return json.username ? json.username : retailerIdInSource;
    } catch (error) {
      return retailerIdInSource;
    }
  }

  componentDidMount() {
    this.saveShopifyWarehouseIdToStateIfExists();
    this.saveWooCommerceWarehouseIdToStateIfExists();
    const { supplierId, getWarehouses } = this.props;
    getWarehouses(supplierId);
    if (this.shouldBlockErpIdEdit()) {
      this.blockErpIdEdit();
    }
  }

  shouldBlockErpIdEdit() {
    return this.state.erpId && this.isJsonWithId(this.props.retailer_id_in_source);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { shopifyCustomerAccountId, woocommerceCustomerAccountId } = this.props;
    if (shopifyCustomerAccountId && prevProps.shopifyCustomerAccountId !== shopifyCustomerAccountId) {
      this.saveShopifyCustomerId();
    }

    if (woocommerceCustomerAccountId && prevProps.woocommerceCustomerAccountId !== woocommerceCustomerAccountId) {
      this.onWoocomreceAccontUpdated();
    }

    if (this.state.erpId !== prevState.erpId) {
      this.saveShopifyWarehouseIdToStateIfExists();
      this.saveWooCommerceWarehouseIdToStateIfExists();
    }

    if (this.shouldBlockErpIdEdit()) {
      this.blockErpIdEdit();
    }
  }

  isJsonWithId(str) {
    let json;
    try {
      json = JSON.parse(str);
      return !!json.id;
    } catch (e) {
      return false;
    }
  }

  reportBi = (event, metaData) => {
    reportBusinessActionToMixpanel(this.props.mixpanel, event, metaData);
  };

  toggleStoresModal(opened) {
    this.setState({
      openStores: opened,
    });
  }

  toggleAccountModal(opened) {
    this.setState({
      openAccountIdModal: opened,
    });
  }

  copyAccountIdToClipboard() {
    copyAccountIdToClipboard(this.accountIdInputText);
    this.props.toastSuccess('Copied to clipboard');
  }

  get accountIdInputText() {
    return getAccountIdInputText(this.props.accountIdConfig);
  }

  toggleWarehousesModal(opened) {
    this.setState({
      openWarehouses: opened,
    });
  }

  saveErpId = () => {
    const { retailer, putPermissions } = this.props;

    this.setState({
      editErpId: false,
    });
    putPermissions(retailer.id, {
      retailer_id_in_source: this.state.erpId,
    });
  };

  editBuffer = () => {
    this.setState({
      editBuffer: true,
    });
  };

  saveBuffer = () => {
    const { retailer, putPermissions } = this.props;

    this.setState({
      editBuffer: false,
    });

    putPermissions(retailer.id, {
      inventory_buffer: +this.state.buffer,
    });
  };

  editMaximumInventory = () => {
    this.setState({
      editMaximumInventory: true,
    });
  };

  saveMaximumInventory = () => {
    const { retailer, putPermissions } = this.props;

    this.setState({
      editMaximumInventory: false,
    });

    putPermissions(retailer.id, {
      max_inventory_visible: +this.state.maximumInventory,
    });
  };

  saveShipperAccount = (shipperAccount) => {
    const removeValue = shipperAccount.carrier === '' || shipperAccount.account === '';
    this.props.updateShipperAccount({
      carrier: removeValue ? null : shipperAccount.carrier,
      account: removeValue ? null : shipperAccount.account,
    });
  };

  saveWarehouses = (warehouses) => {
    const { retailer, putPermissions } = this.props;
    const { approvedWarehouses } = this.state;

    if (warehouses !== false && !isEqual(approvedWarehouses, warehouses)) {
      putPermissions(retailer.id, {
        approved_warehouses: warehouses,
      });

      this.setState({
        approvedWarehouses: warehouses,
      });
    }

    this.toggleWarehousesModal(false);
  };
  saveShopifyCustomerId = () => {
    this.setState(
      {
        erpId: this.props.shopifyCustomerAccountId,
      },
      () => {
        this.toggleAccountModal(false);
        this.saveErpId();
      },
    );
  };

  saveShopifyWarehouseIdToStateIfExists = () => {
    if (!this.isAllowedToSaveCustomerId()) {
      return;
    }
    const { supplierWarehouses } = this.props;
    const shopifyWarehouses = this.getShopifyWarehouses(supplierWarehouses);
    if (!shopifyWarehouses.length) return;

    const shopifyWarehouse = this.getWarehouseWithHighestPriority(shopifyWarehouses);
    this.setState({ shopifyWarehouseId: shopifyWarehouse.id });
  };

  isAllowedToSaveCustomerId = () => {
    const { userRole } = this.props;
    return userRole !== CUSTOMER_ROLE && isEmpty(this.state.erpId);
  };

  updateAccountIdConfig = (data) => {
    const { retailer, supplierId } = this.props;
    this.props.updateAccountIdConfig({ supplierId, retailerId: retailer.id, data });
    this.toggleAccountModal(false);
  };

  saveWooCommerceWarehouseIdToStateIfExists = () => {
    if (!this.isAllowedToSaveCustomerId()) {
      return;
    }
    const { supplierWarehouses } = this.props;
    const wooCommerceWarehouses = this.getWoocommerceWarehouses(supplierWarehouses);
    if (!wooCommerceWarehouses.length) return;

    const wooCommerceWarehouse = this.getWarehouseWithHighestPriority(wooCommerceWarehouses);
    this.setState({ wooCommerceWarehouseId: wooCommerceWarehouse.id });
  };

  getWarehouseWithHighestPriority = (warehouses) => {
    return warehouses.reduce((highestPriorityWarehouse, warehouse) => {
      if (!highestPriorityWarehouse || highestPriorityWarehouse.priority > warehouse.priority) return warehouse;
      return highestPriorityWarehouse;
    }, null);
  };

  getShopifyWarehouses = (warehouses) => {
    return warehouses.filter((warehouse) => {
      return (
        warehouse.orders_integration_type === SHOPIFY_INTEGRATION_TYPE &&
        warehouse.orders_integration_data?.custom_configurations?.use_customer === SHOPIFY_CUSTOMER_TYPE.ACCOUNT_ID &&
        warehouse.is_enabled
      );
    });
  };

  getWoocommerceWarehouses = (warehouses) => {
    return warehouses.filter((warehouse) => {
      return warehouse.orders_integration_type === WOO_COMMERCE_INTEGRATION_TYPE && warehouse.is_enabled;
    });
  };

  handleBufferChange = (value) => {
    this.setState({
      buffer: value,
    });
  };

  handleMaximumInventoryChange = (value) => {
    this.setState({
      maximumInventory: value,
    });
  };

  renderAccountIdInput() {
    const shouldShowInfoTooltip = () =>
      accountIdConfigTooltip.shouldShow(this.props.accountIdConfig) &&
      accountIdConfigTooltip.htmlContent(this.props.accountIdConfig, this.props.warehouses);

    return (
      <div className={styles.editAccountIdInputRow}>
        <span onClick={() => this.toggleAccountModal(true)} className={cn(styles.editIcon, 'ic-edit')} />
        <button onClick={() => this.toggleAccountModal(true)} className={styles.erpid}>
          {this.accountIdInputText}
        </button>
        {shouldShowCopyAccountIdButton(this.accountIdInputText) && (
          <span onClick={() => this.copyAccountIdToClipboard()} className={cn(styles.copyIcon, 'ic-copy')} />
        )}
        {shouldShowInfoTooltip() && (
          <InfoTooltip
            width={300}
            trigger={['hover', 'focus']}
            content={accountIdConfigTooltip.htmlContent(this.props.accountIdConfig, this.props.warehouses)}
          />
        )}
      </div>
    );
  }

  renderInventoryBuffer() {
    const { editBuffer, buffer } = this.state;

    if (editBuffer) {
      return (
        <>
          <span onClick={this.saveBuffer} className={cn(styles.edit, 'ic-save')} />
          <InputNumber
            min={0}
            onFocus={(e) => e.target.select()}
            onClick={(e) => e.target.select()}
            value={buffer}
            onChange={this.handleBufferChange}
            formatter={numberFormatter}
          />
        </>
      );
    } else {
      return (
        <>
          <span onClick={this.editBuffer} className={cn(styles.edit, 'ic-edit')} />
          <button onClick={this.editBuffer} className={styles.erpid}>
            {buffer}
          </button>
        </>
      );
    }
  }
  renderMaximumVisibleInventory() {
    const { editMaximumInventory, maximumInventory } = this.state;

    if (editMaximumInventory) {
      return (
        <>
          <span onClick={this.saveMaximumInventory} className={cn(styles.edit, 'ic-save')} />
          <InputNumber
            min={1}
            onFocus={(e) => e.target.select()}
            onClick={(e) => e.target.select()}
            value={maximumInventory}
            onChange={this.handleMaximumInventoryChange}
            formatter={numberFormatter}
          />
        </>
      );
    } else {
      return (
        <>
          <span onClick={this.editMaximumInventory} className={cn(styles.edit, 'ic-edit')} />
          <button onClick={this.editMaximumInventory} className={styles.erpid}>
            {maximumInventory}
          </button>
        </>
      );
    }
  }

  render() {
    const {
      saveErpId,
      retailer,
      warehouses,
      supplierWarehouses,
      accountIdConfig,
      supplierId,
      isTikTokIntegration,
      brandIdMapping,
      connectionStatus,
    } = this.props;
    const {
      openStores,
      openWarehouses,
      openAccountIdModal,
      approvedWarehouses,
      accountIdTypes,
      openTikTokBrandIdMapperModal,
    } = this.state;

    const { name, stores, id } = retailer;

    const allWarehouses = approvedWarehouses === null || !approvedWarehouses.length;
    const warehousesSources = allWarehouses
      ? 'All sources'
      : `${approvedWarehouses.length} ${formatMany(approvedWarehouses.length, 'source')}`;

    return (
      <div>
        {isTikTokIntegration && (
          <TikTokBrandIdMapperModal
            key={brandIdMapping ? Object.values(brandIdMapping).join('|') : 'no-mapping'}
            open={openTikTokBrandIdMapperModal}
            onClose={() => this.setState({ openTikTokBrandIdMapperModal: false })}
            supplierId={supplierId}
            retailerId={id}
            mapping={brandIdMapping}
          />
        )}
        {openStores ? (
          <StoresModal
            id={id}
            saveErpId={saveErpId}
            name={name}
            stores={stores}
            open={openStores}
            onClose={() => this.toggleStoresModal(false)}
          />
        ) : null}

        {openWarehouses ? (
          <WarehousesModal
            id={id}
            name={name}
            warehouses={warehouses}
            approved={approvedWarehouses}
            open={openWarehouses}
            onClose={this.saveWarehouses}
          />
        ) : null}

        {openAccountIdModal && (
          <AccountIdConfigModal
            open={openAccountIdModal}
            onSave={this.updateAccountIdConfig}
            accountIdConfig={accountIdConfig}
            onClose={() => this.toggleAccountModal(false)}
            retailer={retailer}
            warehouses={supplierWarehouses?.length ? supplierWarehouses : warehouses}
            approvedWarehouses={approvedWarehouses}
            accountIdTypes={accountIdTypes}
          />
        )}
        <div className={styles.singleRetailer}>
          <div className={styles.singleRetailerInfo}>
            <div>
              <h3>General</h3>
              <dl>
                {isTikTokIntegration ? (
                  <>
                    <dt>Connection status:</dt>
                    <dd>
                      <RadioGroup
                        name="Change the status of the connection"
                        onChange={(value) => {
                          this.reportBi('retailer-connection-status-change', {
                            supplierId,
                            retailerId: id,
                            retailerName: retailer.name,
                            status: value,
                          });
                          this.props.toggleTiktokStatus(value, id, supplierId);
                        }}
                        selectedvalue={connectionStatus}
                      >
                        <Radio id="tiktok_status_enabled" value={ENABLED} label="Enabled" />
                        <Radio id="tiktok_status_disabled" value={DISABLED} label="Disabled" />
                      </RadioGroup>
                    </dd>
                  </>
                ) : null}
                <dt>Account ID:</dt>
                <dd>{this.renderAccountIdInput()}</dd>

                <dt>Stores:</dt>
                <dd>
                  <span onClick={() => this.toggleStoresModal(true)} className={cn(styles.edit, 'ic-edit')} />
                  <button className={styles.stores_length_button} onClick={() => this.toggleStoresModal(true)}>
                    {stores.length}
                  </button>
                </dd>

                <dt>Shipper Account:</dt>
                <dd>
                  <ShipperAccount
                    carrier={this.props.replenishment_shipper_account_type}
                    account={this.props.replenishment_shipper_account}
                    onSave={(shipperAccount) => this.saveShipperAccount(shipperAccount)}
                  />
                </dd>
                {isTikTokIntegration && id && supplierId ? (
                  <>
                    <dt>Brand Mapping:</dt>
                    <dd>
                      <span
                        onClick={() => this.setState({ openTikTokBrandIdMapperModal: true })}
                        className={cn(styles.editIcon, 'ic-edit')}
                      />
                      <button
                        className={styles.erpid}
                        onClick={() => this.setState({ openTikTokBrandIdMapperModal: true })}
                      >
                        {isEmpty(brandIdMapping) ? 'None' : `${Object.values(brandIdMapping).length} Brands`}
                      </button>
                    </dd>
                  </>
                ) : null}
              </dl>
            </div>

            <div>
              <h3>Inventory</h3>
              <dl>
                <dt>Warehouse Visibility:</dt>
                <dd>
                  <span onClick={() => this.toggleWarehousesModal(true)} className={cn(styles.edit, 'ic-edit')} />
                  <button className={styles.stores_length_button} onClick={() => this.toggleWarehousesModal(true)}>
                    {warehousesSources}
                  </button>
                </dd>

                <dt>Buffer per SKU:</dt>
                <dd>{this.renderInventoryBuffer()}</dd>

                <dt>Max Visibility per SKU:</dt>
                <dd>{this.renderMaximumVisibleInventory()}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withMixpanel(RetailerDetails);

RetailerDetails.defaultProps = {
  buffer: 0,
  retailer_id_in_source: '',
  replenishment_shipper_account: '',
  replenishment_shipper_account_type: 'ups',
};

RetailerDetails.propTypes = {
  retailer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    stores: PropTypes.array,
  }).isRequired,
  warehouses: PropTypes.array.isRequired,
  approved_warehouses: PropTypes.array,
  retailer_id_in_source: PropTypes.string,
  buffer: PropTypes.number,
  replenishment_shipper_account: PropTypes.string,
  replenishment_shipper_account_type: PropTypes.string,
  putPermissions: PropTypes.func.isRequired,
  saveErpId: PropTypes.func.isRequired,
  updateShipperAccount: PropTypes.func.isRequired,
  userRole: PropTypes.string.isRequired,
  supplierWarehouses: PropTypes.array.isRequired,
  brandIdMapping: PropTypes.object,
  toggleTiktokStatus: PropTypes.func,
  supplierId: PropTypes.number,
  accountIdConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isTikTokIntegration: PropTypes.bool,
  connectionStatus: PropTypes.oneOf([ENABLED, DISABLED]),
};
